module.exports = __webpack_public_path__ + "img/swiper.501194a2.png";